import getErrorKey from '../../components/address/getErrorKey';
import getErrorPrefix from '../getErrorPrefix';

const errorPrefixPlural = 'errors.formFields.minSpecial';

const minSpecialChars = (min, fieldName) => (value) => {
  if (!value) return; // This validator doesn't enforce 'required' constraint, only min length IF value has been provided.
  
  const errorPrefix = getErrorPrefix(errorPrefixPlural, min);
  const errorKey = getErrorKey(fieldName, errorPrefix);
  
  const specialCharString = value.replace(/[a-z]|[A-Z]|[0-9]/g, '');
  
  return specialCharString.trim().length < min ? [errorKey, min] : undefined;
};

export default minSpecialChars;
